import BuyerGroupSup from ".";

export const buyerGroupSupRoutes = [
  {
    path: "/uploadSuppliersManager",
    element: <BuyerGroupSup />,
  },
];
